"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveValueWithPlaceholders = exports.resolveComposedPlaceholderValue = exports.resolvePlaceholderValue = exports.setPlaceholder = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2021 GoodData Corporation
var isArray_1 = tslib_1.__importDefault(require("lodash/isArray"));
var base_1 = require("./base");
/**
 * Set placeholder value to the context.
 * @internal
 */
function setPlaceholder(placeholder, value, state) {
    var _a;
    if (placeholder.validate) {
        placeholder.validate(value);
    }
    if (base_1.isPlaceholder(placeholder)) {
        return tslib_1.__assign(tslib_1.__assign({}, state), { placeholders: tslib_1.__assign(tslib_1.__assign({}, state.placeholders), (_a = {}, _a[placeholder.id] = tslib_1.__assign(tslib_1.__assign({}, placeholder), { value: value }), _a)) });
    }
    return state;
}
exports.setPlaceholder = setPlaceholder;
/**
 * Resolve placeholder value from the context, or fallback to default value.
 * @internal
 */
function resolvePlaceholderValue(placeholder, state) {
    var _a, _b;
    var placeholderValue = (_b = (_a = state.placeholders[placeholder.id]) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : placeholder.defaultValue;
    if (placeholder.validate) {
        placeholder.validate(placeholderValue);
    }
    return placeholderValue;
}
exports.resolvePlaceholderValue = resolvePlaceholderValue;
/**
 * Resolve composed placeholder value with provided resolution context.
 * @internal
 */
function resolveComposedPlaceholderValue(placeholder, state, resolutionContext) {
    var values = placeholder.placeholders.map(function (p) {
        return resolveValueWithPlaceholders(p, state, resolutionContext);
    });
    return placeholder.computeValue(values, resolutionContext);
}
exports.resolveComposedPlaceholderValue = resolveComposedPlaceholderValue;
/**
 * Resolve value(s) that can possibly contain also placeholder(s) to actual value(s).
 * Arrays with nested placeholders that are holding arrays are flattened.
 * You can specify custom resolution context for the composed placeholders.
 *
 * This is method you want to use to replace placeholders in any value with actual placeholder values.
 * It does not support object traversing as most of the visualizations interfaces
 * are consuming only arrays or single values.
 *
 * @internal
 */
function resolveValueWithPlaceholders(value, state, resolutionContext) {
    if (base_1.isPlaceholder(value)) {
        return resolvePlaceholderValue(value, state);
    }
    else if (base_1.isComposedPlaceholder(value)) {
        return resolveComposedPlaceholderValue(value, state, resolutionContext);
    }
    else if (isArray_1.default(value)) {
        return value.reduce(function (acc, v) {
            var resolvedValue = resolveValueWithPlaceholders(v, state, resolutionContext);
            if (base_1.isAnyPlaceholder(v)) {
                // Omit placeholder values that are not set
                if (!resolvedValue) {
                    return acc;
                }
                else if (isArray_1.default(resolvedValue)) {
                    return tslib_1.__spread(acc, resolvedValue.filter(function (v) { return typeof v !== "undefined"; }));
                }
            }
            return tslib_1.__spread(acc, [resolvedValue]);
        }, []);
    }
    return value;
}
exports.resolveValueWithPlaceholders = resolveValueWithPlaceholders;
//# sourceMappingURL=resolve.js.map